<template>
  <div>
    <div class="container" style="">
      <transition name="slide-fade">
        <div class="col-12 pl-md-0 virtulPage" v-show="currentPage=='check'">
          <div class="card col-12">
            <div class="card-header">
              <!-- Title -->
              <h5 class="h3 mb-0">正在检查分享链接的状态</h5>
            </div>
            <!-- Card body -->
            <div class="card-body">
              <div class="p-6" style="display: flex;justify-content: center;align-items: center;flex-direction: column;">
                <i style="font-size: 30px;" class="fa fa-cog fa-spin"></i>
                <div style="margin-top: 10px;">
                  请稍等
                </div>

              </div>
            </div>
          </div>
        </div>
      </transition>
      <transition name="slide-fade">
        <div class="col-12 pl-md-0 virtulPage" v-show="currentPage=='urlError'">
          <div class="card col-12">
            <div class="card-header">
              <!-- Title -->
              <h5 class="h3 mb-0">错误</h5>
            </div>
            <!-- Card body -->
            <div class="card-body">
              <div class="p-6" style="display: flex;justify-content: center;align-items: center;flex-direction: column;">
                <i style="font-size: 50px;color: red;" class="fa fa-times"></i>
                <div style="margin-top: 10px;">
                  分享链接错误或已失效
                </div>

              </div>
            </div>
          </div>
        </div>
      </transition>
      <transition name="slide-fade">
        <div class="col-12 pl-md-0 virtulPage" v-show="currentPage=='password'">
          <div class="card col-12">
            <div class="card-header">
              <!-- Title -->
              <h5 class="h3 mb-0">正在查看分享的文件</h5>
            </div>
            <!-- Card body -->
            <div class="card-body">
              <div class="p-4">
                <input id="pwdInput" type="text" class="form-control form-control-alternative" v-bind:disabled="loading"
                  placeholder="请输入分享密码">
                <br>
                <div style="padding-top: 10px;display: flex;justify-content: center;">
                  <button id="submitPwd" v-bind:disabled="loading" type="button" class="btn btn-primary" @click="submitPwd()">
                    <i v-show="loading==true" style="margin-right: 10px;" class="fa fa-cog fa-spin"></i>
                    <span v-show="loading==true" id="">加载中</span>
                    <span v-show="loading==false" id="">确定</span>
                  </button>
                </div>

              </div>
            </div>
          </div>
        </div>
      </transition>

      <transition name="slide-fade">
        <div class="col-12 pl-md-0" v-show="currentPage=='fileList'" style="max-height: 80vh;padding: 0px;">
          <div class="card col-12">
            <!-- Card header -->
            <div class="card-header">
              <!-- Title -->
              <h5 style="float: left;" class="h3 mb-0">分享文件列表</h5>
              <!-- <div style="float: right;">
                <button @click="saveAll()" type="button" class="btn btn-sm btn-outline-primary">全部转存</button>
              </div> -->
            </div>
            <!-- Card body -->
            <div class="card-body" style="padding: 0;">
              <!-- List group -->
              <share-list @clickItem="clickItem" :shareId="share_id" :fileList="fileList"></share-list>

              <div style="border-top:1px solid #e2e2e2;margin-top: 10px;height: 6vh;display: flex;flex-direction: column;align-items: center;justify-content: center;font-size: 12px;">
                <div id="">
                  文件个数：{{fileList.length}}个
                </div>
                <div id="">
                  过期时间：{{timeRemaining}}
                </div>
              </div>
            </div>
          </div>

        </div>
      </transition>


    </div>
  </div>
</template>
<script>
  import {
    Tooltip
  } from 'element-ui'
  import Share from '@/api/share.js';
  import ShareList from '@/components/ShareList.vue';
  export default {
    name: 'share-page',
    components: {
      [Tooltip.name]: Tooltip,
      ShareList,
    },
    data() {
      return {
        currentPage: 'check',
        loading: false,

        fileList: [],
        timeRemaining: "",
        share_id:"",
        truePwd:"",

        currentFolder:["0"],
      };
    },
    mounted() {
      console.log(this.$route.params.code);
      Share.checkShareStatus(this.$route.params.code).then(res => {
        this.currentPage = "password";
        if(this.$route.params.pwd){
          this.$store.commit("showLoading");
          Share.getShareFileList(this.$route.params.code, this.$route.params.pwd).then(res => {
            this.fileList = res.data.dirs.concat(res.data.files);
            this.currentPage = "fileList";
            this.timeRemaining = res.data.end_date;
            this.share_id=res.data.share_id;
            this.truePwd=this.$route.params.pwd;
            console.log("成功", res);
          }).catch(err => {
            console.log("失败");
            this.$swal.fire(
              '错误',
              "分享密码错误",
              'error'
            );
          }).finally(() => {
            this.$store.commit("hideLoading");
          })
        }
      }).catch(err => {
        console.log("失败");
        this.currentPage = "urlError";
      })
      document.onkeydown = (e) => {
        var ev = document.all ? window.event : e;
        if (ev.keyCode == 13&&this.truePwd=="") {
          this.submitPwd();
        }
      }
    },
    methods: {
      submitPwd() {
        let pwd = $("#pwdInput").val();
        if (pwd.trim() == "") {
          this.$swal.fire(
            '错误',
            "分享密码不能为空",
            'error'
          );
        } else {
          this.$store.commit("showLoading");
          Share.getShareFileList(this.$route.params.code, pwd).then(res => {
            this.fileList = res.data.dirs.concat(res.data.files);
            this.currentPage = "fileList";
            this.timeRemaining = res.data.end_date;
            this.share_id=res.data.share_id;
            this.truePwd=pwd;
            console.log("成功", res);
          }).catch(err => {
            console.log("失败");
            this.$swal.fire(
              '错误',
              "分享密码错误",
              'error'
            );
          }).finally(() => {
            this.$store.commit("hideLoading");
          })
        }
      },
      saveAll() {
        let file_ids=[],dir_ids=[];
        for (let i = 0; i < this.fileList.length; i++) {
          if(this.fileList[i].hasOwnProperty("password")){
            dir_ids.push(this.fileList[i].id);
          }else{
            file_ids.push(this.fileList[i].id);
          }
        }
        this.$store.commit("showLoading");
        Share.save(file_ids,dir_ids,this.share_id).then(res => {
          this.$msgbox.alert(res.messages);
        }).catch(err => {
          console.log("失败");
          this.$msgbox.alert(err.messages);
        }).finally(() => {
          this.$store.commit("hideLoading");
        })
      },
      clickItem(item){
        if(item.hasOwnProperty("password")){
          //打开文件夹
          this.openFolder(item);
        }
      },
      openFolder(item){
        if(item.id=="0"){
          this.$store.commit("showLoading");
          Share.getShareFileList(this.$route.params.code, this.truePwd).then(res => {
            this.fileList = res.data.dirs.concat(res.data.files);
            console.log("成功", res);
            this.currentFolder=["0"];
          }).catch(err => {
            console.log("失败");
            this.$swal.fire(
              '错误',
              "分享密码错误",
              'error'
            );
          }).finally(() => {
            this.$store.commit("hideLoading");
          })
        }else{
          this.$store.commit("showLoading");
          Share.getShareFolderList(this.share_id,item.id).then(res => {
            let isFather = false;
            let indexOfFather = 0;
            for (let i = 0; i < this.currentFolder.length; i++) {
              if (item.id == this.currentFolder[i]) {
                isFather = true;
                indexOfFather = i;
              }
            }
            //如果是上级目录,则切割数组
            if (isFather) {
              console.log("isfather");
              this.currentFolder = this.currentFolder.slice(0, indexOfFather + 1);
            } else {
              //否则加入数组
              this.currentFolder.push(item.id)
            }

            let rootDir=[
              {
                "id":this.currentFolder[this.currentFolder.length>1?this.currentFolder.length-2:"0"],
                "password":"123",
                "name":"<返回上级",
              }
            ];
            this.fileList = rootDir.concat(res.data.dirs.concat(res.data.files));
            console.log(res);
          }).catch(err => {
            console.log("失败");
            this.$swal.fire(
              '错误',
              "分享密码错误",
              'error'
            );
          }).finally(() => {
            this.$store.commit("hideLoading");
          })
        }
      },

    }
  };
</script>
<style scoped="scoped">
  .slide-fade-enter-active {
    transition: all 1s ease;
  }

  .slide-fade-leave-active {
    opacity: 0;
    position: absolute;
    /* top: 150px;
  				width: 100%;
  				transition: all .1s cubic-bezier(1.0, 0.5, 0.8, 1.0); */
  }

  .slide-fade-enter,
  .slide-fade-leave-to

  /* .slide-fade-leave-active 用于 2.1.8 以下版本 */
    {
    transform: translateY(-100px);
    opacity: 0;
  }

  .card {
    box-shadow: 0 15px 35px rgba(50, 50, 93, 0.8), 0 5px 15px rgba(0, 0, 0, .07);
  }

  .virtulPage {
    background-color: transparent;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }
</style>
